import camelCase from "lodash/camelCase";

/**
 * Format object data
 * @param {object} param - object passed into avoFormatter function
 * @returns {object} - return object with formatted keys
 */
export const avoFormatter = (data) => {
  const formattedData = {};
  for (let i = 0; i < Object.keys(data).length; i++) {
    const key = Object.keys(data)[i];
    if (key.includes("_")) {
      formattedData[camelCase(key)] = data[key];
    } else {
      formattedData[key] = data[key];
    }
  }

  return formattedData;
};
